// @flow
import React, { Component } from 'react';

import '../StoresGrid/StoresGrid.css';


export default class PatternGrid extends Component {

    render () {

        let stores = [
            {
                url: 'http://cottonbee.pl/autor/KatarzynaPilipionek',
                logoPath: '/stores/cottonbee_compressed.jpg',
                description: 'my patterns & products at cottonbee'
            },
            {
                url: 'https://ku-ka.pl/pl/130_laura-nor',
                logoPath: '/stores/kuka_compressed.jpg',
                description: 'my patterns & products at kuka'
            },
            {
                url: 'https://www.spoonflower.com/profiles/lauranor',
                logoPath: '/stores/spoonflower_compressed.jpg',
                description: 'my patterns & products at spoonflower'
            },
            {
                url: 'https://society6.com/lauranor',
                logoPath: '/stores/society6_compressed.jpg',
                description: 'my patterns & products at society6'
            },
        ];

        let storesHtml = stores.map(store => {
            return (
                <div className="col s12 m6 l4 ln-tile">
                    <div
                        className="ln-tile-container">
                        <a
                            href={ store.url }
                            target="_blank"
                            rel="noopener noreferrer">
                            <img
                                src={ store.logoPath }
                                alt={ store.description } />

                            <div
                                className="ln-overlay">
                            </div>
                        </a>
                    </div>
                </div>
            )
        });

        return (
            <div>
                <div
                    className="row">
                    { storesHtml }
                </div>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/StoresGrid/StoresGrid.js